import { createCtx } from "@tiny/utils/react/createContext";
import { ScreenLoaderManagerContext } from "./ScreenLoaderManager.types";

const [useScreenLoaderManager, ScreenLoaderManagerProvider] =
  createCtx<ScreenLoaderManagerContext>();

export { useScreenLoaderManager, ScreenLoaderManagerProvider };
